<script>
/**
 * 工厂参观（自 vancheen-b2b 的 FactoryView.vue 移植为 Vue 2 版本）
 * 结构：page-hero → 合作工厂实拍照片墙（两列）→ CTA 条 → 收尾语。
 */
import NhShell from '../components/NhShell.vue'
import NhCtaBand from '../components/NhCtaBand.vue'
import NhPageHero from '../components/NhPageHero.vue'
import NhSectionHead from '../components/NhSectionHead.vue'
import asset from '../nh-asset'
import { getSite } from '../nh-site-data'
import { t, setPageTitle } from '../nh-i18n'

export default {
  name: 'NhFactoryPage',
  components: { NhShell, NhCtaBand, NhPageHero, NhSectionHead },
  computed: {
    FACTORY_PHOTOS() {
      return getSite('FACTORY_PHOTOS')
    },
    CTA_FACTORY() {
      const cta = getSite('CTA')
      return cta ? cta.factory : { title: '', desc: '', actions: [] }
    }
  },
  mounted() {
    setPageTitle('factory')
  },
  methods: {
    asset,
    t
  }
}
</script>

<template>
  <NhShell>
    <NhPageHero :crumbs="[{ label: t('crumbs.home'), to: '/' }, { label: t('factory.crumb') }]"
      :eyebrow="t('factory.eyebrow')" :title="t('factory.title')" :desc="t('factory.desc')" />

    <!-- ===== 合作工厂实拍照片墙 ===== -->
    <section class="section">
      <div class="container">
        <NhSectionHead :kicker="t('factory.photosKicker')" :title="t('factory.photosTitle')"
          :desc="t('factory.photosDesc')" />

        <div class="photo-wall">
          <figure v-for="(item, i) in FACTORY_PHOTOS" :key="item.title" v-reveal="i || undefined" class="photo-tile">
            <div class="photo-media" :class="{ 'is-empty': !item.img }">
              <img v-if="item.img" :src="asset(item.img)" :alt="item.alt">
              <span class="photo-tag">{{ item.tag }}</span>
            </div>
            <figcaption class="photo-cap">
              <h3>{{ item.title }}</h3>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>

    <!-- ===== 预约参观 ===== -->
    <NhCtaBand :title="CTA_FACTORY.title" :desc="CTA_FACTORY.desc" :actions="CTA_FACTORY.actions" />

    <p class="factory-note">{{ t('factory.note') }}</p>
  </NhShell>
</template>
